// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-range-picker-v2 ::ng-deep .mat-mdc-text-field-wrapper {
  height: 32px;
}
.date-range-picker-v2 ::ng-deep .mdc-text-field--filled {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
  padding: 0 4px 0 12px;
}
.date-range-picker-v2 ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: #fff;
}
.date-range-picker-v2 ::ng-deep .mat-mdc-form-field-infix {
  padding-top: 0;
  padding-bottom: 0;
  min-height: auto;
}
.date-range-picker-v2 ::ng-deep .mat-mdc-form-field-flex {
  align-items: center;
  height: 100%;
}
.date-range-picker-v2 ::ng-deep .mdc-text-field__input {
  padding-top: 0;
  padding-bottom: 0;
  font-size: 13px;
}
.date-range-picker-v2 ::ng-deep .mat-mdc-form-field-icon-suffix {
  padding: 0;
}
.date-range-picker-v2 ::ng-deep .drp-clear-btn {
  position: absolute;
  right: 36px;
  top: 50%;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #888;
  font-size: 16px;
  line-height: 18px;
  z-index: 1;
}
.date-range-picker-v2 ::ng-deep .drp-clear-btn:hover {
  color: #333;
}
.date-range-picker-v2 ::ng-deep .mat-mdc-icon-button {
  width: 28px;
  height: 28px;
  padding: 0;
}
.date-range-picker-v2 ::ng-deep .mat-mdc-icon-button .mat-mdc-button-touch-target {
  width: 28px;
  height: 28px;
}
.date-range-picker-v2 ::ng-deep .mat-mdc-icon-button .mat-icon,
.date-range-picker-v2 ::ng-deep .mat-mdc-icon-button svg {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}
.date-range-picker-v2 ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.date-range-picker-v2 ::ng-deep .mdc-line-ripple {
  display: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
